<template>
  <div id="loadScreen">
    <div class="loader">
      <img
        src="https://2020-uki.s3.eu-west-2.amazonaws.com/PA_Onboarding/logos/GettyImages_White.svg"
        class="loading-logo"
      />
      <div class="loadbar-container">
        <div class="loadbar"></div>
        <div class="loadbar2"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
#loadScreen {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: var(--gi-black);
  z-index: 222;
  display: flex;
  align-items: center;
  justify-content: center;
}
i {
  font-size: 50px;
}

.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 200px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.loading-logo {
  width: 160px;
  margin: 0 auto 20px;
}

.loadbar-container {
  position: relative;
  width: 160px;
  margin: 0 auto;
}

.loadbar {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  border-top: 5px solid var(--gi-purple);
  -webkit-transform: scaleX(0);
  -ms-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transform-origin: left center;
  -ms-transform-origin: left center;
  transform-origin: left center;
  -webkit-animation-name: loading1;
  animation-name: loading1;
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  z-index: 1;
}

.loadbar2 {
  content: "";
  position: absolute;
  top: -1px;
  left: 0;
  width: 100%;
  border-top: 7px solid var(--gi-black);
  -webkit-transform: scaleX(0);
  -ms-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transform-origin: left center;
  -ms-transform-origin: left center;
  transform-origin: left center;
  -webkit-animation-name: loading2;
  animation-name: loading2;
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  z-index: 2;
}

@-webkit-keyframes loading1 {
  0% {
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
  }

  50% {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  100% {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

@keyframes loading1 {
  0% {
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
  }

  50% {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }

  100% {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

@-webkit-keyframes loading2 {
  0% {
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
  }

  50% {
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
  }

  100% {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

@keyframes loading2 {
  0% {
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
  }

  50% {
    -webkit-transform: scaleX(0);
    transform: scaleX(0);
  }

  100% {
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}
</style>